import $ from 'jquery';
import 'slick-carousel';

export default class StatsCarousel {
  constructor(el) {
    this.el = el;

    const items = el.querySelectorAll('[data-carousel-items]');
    const speed = el.dataset.carouselSpeed ? el.dataset.carouselSpeed : 5000;

    $(function () {
      $(items).slick({
        autoplay: true,
        autoplaySpeed: speed,
        infinite: true,
        slidesToShow: 1,
        arrows: false,
        dots: false,
        adaptiveHeight: false,
        draggable: true,
        cssEase: 'ease-in-out',
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/StatsCarousel.js